<template>
  <div class="sale-list">
    <Row>
      <Col v-for="(item,index) in saleListConfig" :key="index" :span="item.width">
        <div class="sale-list-item" v-if="item.content.length>1">
          <div class="sale-icon" v-show="item.isShow">
            <img :src="item.url" :width="item.img_width" :height="item.img_height">
          </div>
          <div class="sale-target-content">
            <div class="content-item" v-for="(contentItem,acindex) in item.content" :key="acindex">
              <p>{{contentItem.value}}</p>
              <span :title='contentItem.label'>{{contentItem.label}}</span>
            </div>
          </div>
        </div>
        <div class="sale-list-item" v-else>
          <div class="sale-icon" style="border-right:none" v-show="item.isShow">
            <img :src="item.url" :width="item.img_width" :height="item.img_height">
          </div>
          <div class="sale-target-content" v-if="item.content.length>0">
            <div class="content-item" v-for="(contentItem,acindex) in item.content" :key="acindex">
              <p>{{contentItem.value}}</p>
              <span :title='contentItem.label'>{{contentItem.label}}</span>
            </div>
          </div>
        </div>
      </Col>
    </Row>
  </div>
</template>
<script>
export default {
  props: {
    saleListConfig: {
      type: Array
    }
  }
};
</script>
<style lang="less">
.sale-list {
  width: 100%;
  .ark-col.ark-col-span-1,
  .ark-col.ark-col-span-2,
  .ark-col.ark-col-span-3,
  .ark-col.ark-col-span-4,
  .ark-col.ark-col-span-5,
  .ark-col.ark-col-span-6,
  .ark-col.ark-col-span-7,
  .ark-col.ark-col-span-8,
  .ark-col.ark-col-span-9,
  .ark-col.ark-col-span-10,
  .ark-col.ark-col-span-11,
  .ark-col.ark-col-span-12,
  .ark-col.ark-col-span-13,
  .ark-col.ark-col-span-14,
  .ark-col.ark-col-span-15,
  .ark-col.ark-col-span-16,
  .ark-col.ark-col-span-17,
  .ark-col.ark-col-span-18,
  .ark-col.ark-col-span-19,
  .ark-col.ark-col-span-20,
  .ark-col.ark-col-span-21,
  .ark-col.ark-col-span-22,
  .ark-col.ark-col-span-23,
  .ark-col.ark-col-span-24 {
    border: 1px solid #ccc;
    border-right: none;
    &:last-child {
      border-right: 1px solid #ccc;
    }
  }
  .sale-list-item {
    display: -webkit-flex; /* Safari */
    display: flex;
    box-sizing: border-box;
    .sale-icon {
      flex: 2;
      display: -webkit-flex;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
      }
      border-right: 1px solid #ccc;
    }
    .sale-target-content {
      flex: 3;
      box-sizing: border-box;
      display: -webkit-flex; /* Safari */
      display: flex;
      flex-direction: column;
      .content-item {
        box-sizing: border-box;
        flex: 1;
        padding: 8px;
        border-bottom: 1px solid #ccc;
        text-align: center;
        p {
          font-size: 14px;
          line-height: 30px;
          flex: 1;
          color: #fd6442;
          &:hover {
            font-weight: 600;
          }
        }
        span {
          line-height: 30px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
          width: 100%;
          height: 30px;
          display: block;
        }
        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
}
</style>
